// purchaseManagment

import { Product, ProductVariant } from '../productManagment/types';
import { User } from '../userManagment/types';
import { DetailledIpAddressInformations } from '../networkManagment/types';

export interface AppliedDiscount
 {
  type           : string ,
  condition      : string ,
  value          : string ,
  priceToApplyOn : string ,
 }

export interface Item
 {
  productId        : number ,
  productVariantId : number ,
  quantity         : number ,
  basePriceCopy    : number ,
  taxRateCopy      : number ,
  totalPrice       : number ,
  priceCode        : number ,
  priceToPayCopy   : number ,
  itemDescription  : string
  appliedDiscounts : AppliedDiscount[]
 }

export interface Purchase
 {
  id           : number ,
  amount       : number ,
  comment      : string ,
  ipAddress    : string ,
  creationDate : Date | null   ,
  cart         : Item[] ,
  userId       : number
 }
 
export const initializedPurchase = (): Purchase => ( 
 {
  id           : 0  ,
  amount       : 0  ,
  comment      : "" ,
  ipAddress    : "" ,
  creationDate : null ,
  cart         : [] ,
  userId       : 0
});

export const initializedItem = (): Item => ( 
 {
  productId                         : 0  ,
  productVariantId                  : 0  ,
  quantity                          : 0  ,
  basePriceCopy                     : 0  ,
  taxRateCopy                       : 0  ,
  totalPrice                        : 0  ,
  priceCode                         : 0  ,
  priceToPayCopy                    : 0  ,
  itemDescription                   : "" ,
  appliedDiscounts                  : []
});

// Nouvelle interface enrichie pour les items
export interface EnrichedItem extends Item {
  product?: Product;
  productVariant?: ProductVariant;
}

// Nouvelle interface enrichie pour les achats
export interface EnrichedPurchase extends Purchase {
  cart: EnrichedItem[];
  user?: User;
  ipDetails?: DetailledIpAddressInformations;
}

export const initializedEnrichedPurchase = (): EnrichedPurchase => ({
  ...initializedPurchase(),
  cart: [],
  user: undefined,
  ipDetails: undefined
});

// ── Panier (achat non payé) — forme renvoyée par purchase_infos_by_email ────────
//
// Différente de Purchase/Item ci-dessus (qui reflètent la forme imbriquée dans un
// Payment, cf. payment_list) : ici les articles sont identifiés par CODE
// (productCode/productVariantCode/priceCode, nécessaires à add_item/remove_item/
// change_quantity_of_item), pas par id, et il n'y a ni itemDescription ni
// appliedDiscounts.

export interface CartItem
 {
  productCode        : string ,
  productVariantCode : string ,
  quantity            : number ,
  priceCode          : string ,
  basePriceCopy      : number ,
  taxRateCopy        : number ,
  priceToPayCopy     : number ,
  totalPrice         : number ,
 }

export interface Cart
 {
  id           : number ,
  amount       : number ,
  comment      : string ,
  ipAddress    : string ,
  creationDate : Date | null ,
  soldItems    : CartItem[] ,
 }

export const initializedCart = (): Cart => (
 {
  id           : 0  ,
  amount       : 0  ,
  comment      : "" ,
  ipAddress    : "" ,
  creationDate : null ,
  soldItems    : [] ,
});
